import {getMiddleware} from '@helpers/middleware';
import AutocompleteHelper from '@components/chat/autocompleteHelper';

export default class AutocompleteHelperController {
  private helpers: Set<AutocompleteHelper> = new Set();
  private middleware = getMiddleware();
  /* private tempId = 0;

  public incrementToggleCount() {
    return ++this.tempId;
  }

  public getToggleCount() {
    return this.tempId;
  } */

  public toggleListNavigation(enabled: boolean) {
    for(const helper of this.helpers) {
      helper.toggleListNavigation(enabled);
    }
  }

  public destroy() {
    this.middleware.destroy();
    this.hideOtherHelpers();
  }

  public getMiddleware() {
    this.middleware.clean();
    return this.middleware.get();
  }

  public addHelper(helper: AutocompleteHelper) {
    this.helpers.add(helper);
  }

  public hideOtherHelpers(
    preserveHelpers?: Set<AutocompleteHelper>,
    skipAnimation = false
  ) {
    this.helpers.forEach((helper) => {
      if(!preserveHelpers?.has(helper)) {
        helper.toggle(true, true, skipAnimation);
      }
    });

    if(!preserveHelpers?.size) {
      this.middleware.clean();
    }
  }
}
